import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, ViewChild, Injector, runInInjectionContext, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoginActionStatusService } from '../shared/actionStatus.service';
import { AssignmentService } from "../shared/assignment.service";
import { AuthService } from '../shared/auth.service';
import { FrameShowService } from '../shared/FrameShowService';
import { PointsMechanismService } from '../shared/point-mechanism.service';
import { firstValueFrom, Subscription } from 'rxjs';

@Component({
	selector: 'app-game',
	templateUrl: './game.component.html',
	standalone: false
})
export class GameComponent implements OnInit, AfterViewInit, OnDestroy {
	name: string;
	totalScore: number;

	userInfo: any;

	hasFrame = true;
	background: string;
	public completion: any = null;
	pay = false;
	phaser2 = null;
	phaser3 = null;

	isAdmin = false;
	today = new Date();

	showAssignmentWarning = false;

	mousemoveCount = 33;

	showAssignmentPopup = false;

	parentData: any = {};

	showAssignmentDone = false;
	assignmentDoneLesson = 0;
	assignmentDoneTitle = "";
	assignmentDoneLessonText = "";

	childs = [];

	skipLoadCount = 3;

	private channel: BroadcastChannel;
	private subscriptions: Subscription = new Subscription();

	@ViewChild('game') game: ElementRef;

	@HostListener('mousemove', ['$event'])
	onMouseMove(e) {
		if (this.mousemoveCount == 33 || this.mousemoveCount <= 0) {
			this.pm.updateTimer();
			if (this.mousemoveCount <= 0) this.mousemoveCount = 33;
		} else {
			--this.mousemoveCount;
		}
	}

	constructor(
		private afs: AngularFirestore,
		private meta: Meta,
		private activatedRoute: ActivatedRoute,
		private frameService: FrameShowService,
		private pm: PointsMechanismService,
		public assignmentService: AssignmentService,
		private router: Router,
		private actionStatus: LoginActionStatusService,
		private auth: AuthService,
		private ngZone: NgZone,
		private injector: Injector,
		private cdr: ChangeDetectorRef // ✨ INJECTED CHANGE DETECTOR ✨
	) {
		this.channel = new BroadcastChannel('SESSION_ACTIONS');

		this.channel.onmessage = (event) => {
			if (event.data.action == "LOGOUT") {
				localStorage.clear();
				sessionStorage.clear();
				this.ngZone.run(() => this.router.navigate(['/login']));
			}
		};

		this.phaser2 = window['Phaser'];

		this.meta.updateTag({ name: 'viewport', content: 'width=1266, initial-scale=1' });

		this.subscriptions.add(this.frameService.background.subscribe(value => {
			this.background = '/assets/images/bg/bg-' + value + '.jpg';

			const bgElement = document.getElementById("bgID");
			if (bgElement) bgElement.style.backgroundImage = 'url("' + this.background + '")';
		}));

		this.subscriptions.add(this.frameService.continentCompletion.subscribe(item => {
			this.completion = item;
		}));

		this.assignmentService.firstCallback = () => {
			if (window.location.pathname != "/game/my-assignments") this.showAssignmentPopupClick();
		};

		if (this.assignmentService.load && !this.assignmentService.canAccessAnotherGames() && this.assignmentService.isFirst) {
			if (this.assignmentService.list.length) {
				this.assignmentService.isFirst = false;
				this.showAssignmentPopupClick();
			}
		}
	}

	ngOnInit() {
		this.subscriptions.add(this.auth.onUserUpdate.subscribe(async userData => {
			if (userData != null && userData) {
				await this.loadChildData(userData);
			}
		}, error => {
			console.log('error', error);
		}));

		this.subscriptions.add(this.router.events.subscribe(val => {
			if (val instanceof NavigationEnd) {
				this.checkUrl(val.url);
			}
		}, error => {
			console.log('error', error);
		}));
		this.checkUrl(this.router.url);

		var assignmentData = localStorage.getItem("showAssignmentPopUp");

		if (assignmentData) {
			this.showAssignmentDone = true;
			if (assignmentData == "AllDone") {
				this.assignmentDoneLesson = -1;
				this.assignmentDoneTitle = "Well Done!";
			} else {
				this.assignmentDoneTitle = "Great job!";
				this.assignmentDoneLesson = 1;
				this.assignmentDoneLessonText = assignmentData;
			}

			localStorage.removeItem("showAssignmentPopUp");
		}

		this.subscriptions.add(this.activatedRoute.queryParams.subscribe(params => {
			if (params['paymentFalse']) {
				this.pay = true;
			}
		}, error => {
			console.log('error', error);
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
		if (this.channel) {
			this.channel.close();
		}
	}

	async loadChildData(userData) {
		const adminUserData = localStorage.getItem('quranera_admin_userData');
		if (adminUserData) {
			const aUserData = JSON.parse(adminUserData);
			this.isAdmin = ['admin', 'admin_teacher', 'teacher'].indexOf(aUserData.role) > -1;
		}

		if (!userData) {
			if (adminUserData) {
				userData = JSON.parse(adminUserData);
				userData.totalScore = 0;
				userData.name = userData.firstname + ' ' + userData.lastname;
				userData.activeLevel = '1-1-1';
				userData.avatar = 'b1';
			}
		}
		this.userInfo = userData;

		if (userData) {
			this.totalScore = userData.totalScore;

			if (userData.school) {
				try {
					// ✨ Using .get() for safer async resolution
					const schoolDoc: any = await runInInjectionContext(this.injector, () =>
						firstValueFrom(this.afs.collection("schoolsData").doc(userData.school).get())
					);

					if (schoolDoc.exists) {
						const schoolData = schoolDoc.data();
						if (schoolData.Status && (schoolData.Status === "Expired" || schoolData.Status === "NotConverted")) {
							setTimeout(() => {
								window.location.reload();
							}, 2000);
							this.logout();
						}
					}
				} catch (error) {
					console.error("Error fetching school data:", error);
				}
			}
		}
		else {
			this.totalScore = 0;
		}

		if (userData && userData.parentId) {
			try {
				// ✨ Await Parent Data safely using .get()
				const parentDoc: any = await runInInjectionContext(this.injector, () =>
					firstValueFrom(this.afs.collection('parents').doc(userData.parentId).get())
				);

				if (parentDoc.exists) {
					this.parentData = parentDoc.data();
				}

				// ✨ Await Children Data safely using .get()
				const childrenSnap: any = await runInInjectionContext(this.injector, () =>
					firstValueFrom(this.afs.collection('userData', ref => ref.where('parentId', '==', userData.parentId)).get())
				);

				// Map the resulting snapshot documents to the data array
				this.childs = childrenSnap.docs.map(doc => doc.data());
			} catch (error) {
				console.error("Error fetching parent/child data:", error);
			}
		}

		this.name = this.userInfo.name || "";
		if (this.name.length > 9) {
			this.name = this.name.substring(0, 9) + '.';
		}
		this.background = '/assets/images/bg/bg-' + userData.activeLevel + '.jpg';
		this.setHoverClickEvents();

		// 🚀 THE MAGIC FIX: Force Angular to update the HTML immediately
		this.cdr.detectChanges();
	}

	ngAfterViewInit(): void {
		this.setHoverClickEvents();
		this.game.nativeElement.dispatchEvent(new Event('touchstart'));
	}

	toDateString(date: number) {
		return new Date(date * 1000).toLocaleDateString("ru-RU");
	}

	setHoverClickEvents() {
		setTimeout(() => {
			var buttons = document.querySelectorAll('.logout');
			for (var i = 0; i < buttons.length; i++) {
				buttons[i].addEventListener('click', function (event) {
					let audio = <HTMLAudioElement>document.getElementById('menuButtonClick');
					if (audio)
						if (audio) audio.play();
				});
				buttons[i].addEventListener('mouseover', function (event) {
					let audio = <HTMLAudioElement>document.getElementById('menuButtonHover');
					if (audio) {
						audio.currentTime = 0;
						if (audio) audio.play();
					}
				});
			}

			buttons = document.querySelectorAll('.profile-box .avatar');
			for (var i = 0; i < buttons.length; i++) {
				buttons[i].addEventListener('click', function (event) {
					let audio = <HTMLAudioElement>document.getElementById('menuButtonClick');
					if (audio)
						if (audio) audio.play();
				});
				buttons[i].addEventListener('mouseover', function (event) {
					let audio = <HTMLAudioElement>document.getElementById('menuButtonHover');
					if (audio) {
						audio.currentTime = 0;
						if (audio) audio.play();
					}
				});
			}

			buttons = document.querySelectorAll('.menu a');
			for (var i = 0; i < buttons.length; i++) {
				buttons[i].addEventListener('click', function (event) {
					let audio = <HTMLAudioElement>document.getElementById('menuButtonClick');
					if (audio) {
						if (audio) audio.play();
					}
				});
				buttons[i].addEventListener('mouseover', function (event) {
					let audio = <HTMLAudioElement>document.getElementById('menuButtonHover');
					if (audio) {
						audio.currentTime = 0;
						if (audio) audio.play();
					}
				});
			}
		}, 100)
	}

	private async checkUrl(url: string) {
		let match = url.includes('activity-');
		let free = url.includes('1-1-1');

		if (match && !free) {
			let isActiveUser = this.auth.isActiveUser;

			if (this.isAdmin || isActiveUser) {
				return true;
			}
			else {
				const adminUserData = localStorage.getItem('quranera_admin_userData');
				if (adminUserData) {
					return true;
				}
				this.router.navigate(['/game'], { queryParams: { paymentFalse: true } });
				return false;
			}
		}
		else {
			return true;
		}
	}

	okClick() {
		this.pay = false;
		this.actionStatus.action.next(this.notifyMode());
	}

	next() {
		this.completion = null;
		this.router.navigate(['/game/continents']);
	}

	closeAssignmentPopup(e) {
		e.preventDefault();
		e.stopPropagation();
		this.showAssignmentPopup = false;
	}

	showAssignmentPopupClick() {
		this.showAssignmentPopup = true;
	}

	showAssignmentWarningPopupClick() {
		this.showAssignmentWarning = true;

		this.showAssignmentPopupClick();
	}

	closeAssignmentCongrat() {
		this.showAssignmentDone = false;
		window.location.reload();
	}

	logout() {
		localStorage.clear();
		sessionStorage.clear();

		this.channel.postMessage({ action: 'LOGOUT' });

		this.router.navigate(['/login']);
	}

	goToGame(item) {
		var route = item.assignment.lesson;
		this.showAssignmentPopup = false;
		if (item.gameType === 'quiz') {
			this.router.navigate(['/game/quiz-activity/' + item.gameId]);
		} else {
			this.router.navigate(['/game/activity-list/' + route]);
		}

		this.showAssignmentPopup = false;
	}

	notifyMode() {
		let result = 1;
		let payedCount = 0;

		if (this.childs && this.childs.length > 0) {
			this.childs.forEach(child => {
				if (child.paymentStatus) {
					payedCount++;
				}
			});

			if (payedCount == 0 && !this.parentData.isUsedTrial && this.childs.length == 1) {
				result = 1;
			} else if (payedCount == 0 && this.parentData.isUsedTrial && this.childs.length == 1) {
				result = 2;
			} else if (payedCount == 0 && this.childs.length > 1) {
				result = 2;
			} else {
				result = 3;
			}

			if ((this.userInfo.activities["1-1-2"] && this.userInfo.activities["1-1-2"]["2"])
				|| (this.userInfo.activities["1-1-2"] && this.userInfo.activities["1-1-2"]["4"])
				|| (this.userInfo.activities["1-1-3"] && this.userInfo.activities["1-1-3"]["2"])
				|| (this.userInfo.activities["1-1-3"] && this.userInfo.activities["1-1-3"]["5"])
				|| (this.userInfo.activities["1-1-4"] && this.userInfo.activities["1-1-4"]["2"])
				|| (this.userInfo.activities["1-1-4"] && this.userInfo.activities["1-1-4"]["7"])
			) result = 2;
		}
		return result;
	}

	firstChild() {
		let result = false;
		let payedCount = 0;

		if (this.parentData.isUsedTrial) return false;

		if (this.childs && this.childs.length > 1) {
			this.childs.forEach(child => {
				if (child.paymentStatus) {
					payedCount++;
				}
			});
			if (payedCount == 0) {
				result = true;
			}
		}
		else if (this.childs && this.childs.length == 1) {
			result = true;
		}
		return result;
	}
}
